/**
 * Created by smizrahi on 4/25/17.
 */

import Persistence from "../../../../persistence/Persistence";
import Security from "../../../../utils/Security"

const BEST_MSCORE_SERVER_KEY = 'BEST_MSCORE_SERVER';

export default class MscoreStepPersist extends Persistence {

    /**
     * Generate a md5 hash from configuration
     *
     * @param {MScoreStepConfig} configuration
     * @returns {string} MD5 hash
     */
    generateHash(configuration) {
        return (new Security()).md5(JSON.stringify(configuration));
    }

    /**
     * Save an url for a specific configuration
     *
     * @param {string} url
     * @param {MScoreStepConfig} configuration
     */
    saveBestMscoreServer(url, configuration) {
        let hash = this.generateHash(configuration);
        let mscoreBestServers = JSON.parse(this.get(BEST_MSCORE_SERVER_KEY));
        if (!mscoreBestServers) {
            mscoreBestServers = {};
        }

        mscoreBestServers[hash] = url;
        super.set(BEST_MSCORE_SERVER_KEY, JSON.stringify(mscoreBestServers));
    }

    /**
     * Return the best URL for the configuration, null if nothing found
     *
     * @param {MScoreStepConfig} configuration
     * @returns {string,null} The URL
     */
    getBestMscoreServer(configuration) {
        let hash = this.generateHash(configuration);
        let mscoreBestServers = JSON.parse(super.get(BEST_MSCORE_SERVER_KEY));
        if (mscoreBestServers && mscoreBestServers[hash]) {
            return mscoreBestServers[hash];
        }

        return null;
    }

    /**
     * Clean the local storage stuff
     */
    clean() {
        super.delete(BEST_MSCORE_SERVER_KEY);
    }
}


// WEBPACK FOOTER //
// ./js/core/script/executors/mscore/persistence/MscoreStepPersist.js